<!-- src/app/app.component.html -->

@if (isPrintView()) {
  <router-outlet />
} @else {
  <lib-layout
    [navLinks]="navLinks"
    [assets]="assets"
  >
    <router-outlet />
  </lib-layout>
}
